import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { WorkUnit } from '@core/models/work-unit.model';
import { WorkGroupsCoreService } from '@core/services/features/work-groups-core.service';
import { WorkUnitCoreService } from '@core/services/features/work-unit-core.service';
import { coreSelectors } from '@core/store/core.selectors';
import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { createQuery, filterTruthy } from '@utils';
import { DateTime } from 'luxon';
import { BehaviorSubject, concat, Subscription } from 'rxjs';
import { concatMap, pluck } from 'rxjs/operators';

import it from './i18n/select-work-unit-session.it.json';

@Component({
  templateUrl: './select-work-unit-session.component.html',
  styles: [
  ]
})
export class SelectWorkUnitSessionComponent implements OnInit, OnDestroy {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();


  currentUser$ = this.store.select(coreSelectors.currentUser);

  groups$ = this.currentUser$.pipe(
    filterTruthy(),
    concatMap(user => this.wuGrpCoreSvc.getList({ userId: user.id }))
  );

  private workUnits$$ = new BehaviorSubject<WorkUnit[] | undefined>(undefined);
  workUnits$ = concat(
    this.wuCoreSvc.getByQuery(createQuery({ size: 1000 })).pipe(pluck('results')),
    this.workUnits$$.pipe(filterTruthy())
  );

  inputForm: FormGroup = this.fb.group({
    groupId: [],
    workUnitId: [undefined, [Validators.required]]
  });

  private subs = new Subscription();

  constructor(
    private fb: FormBuilder,
    private wuGrpCoreSvc: WorkGroupsCoreService,
    private wuCoreSvc: WorkUnitCoreService,
    private translocoSvc: TranslocoService,
    private store: Store
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    this.subs.add(
      this.inputForm.controls.groupId.valueChanges.pipe(
        concatMap(groupId => groupId ?
          this.wuCoreSvc.getListByGroupId(groupId) :
          this.wuCoreSvc.getByQuery(createQuery({ size: 1000 })).pipe(pluck('results'))
        )
      ).subscribe(workUnits => {
        this.workUnits$$.next(workUnits);
        this.inputForm.controls.workUnitId.setValue(undefined);
      })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  submit(form: FormGroup) {
    if (form.valid) {
      const now = DateTime.local();
      const { workUnitId } = form.value;
      const value: SessionStepValue = {
        workflowId: this.step.workflowId,
        workflowStepId: this.step.workflowStepId,
        sessionId: this.step.sessionId,
        timestamp: now.toJSDate(),
        type: SessionStepValueType.inputNumber,
        value: { input: workUnitId } as InputJson
      };
      this.commitAndNext.emit({ ...this.step, completedOn: now.toJSDate(), values: [value] });
    }
  }
}
